import { AlertTriangle, Check } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { tint } from "@/lib/mall";

/** Before / after, side by side, with the one rule to remember. */
export function Lessons({ lessons, theme }) {
    return (
        <div className="space-y-10" data-testid="artwork-lessons">
            {lessons.map((l, i) => (
                <Reveal key={l.key} delay={i * 0.04}>
                    <div className={`grid items-center gap-7 lg:grid-cols-2 ${i % 2 ? "lg:[&>*:first-child]:order-2" : ""}`}
                        data-testid={`lesson-${l.key}`}>
                        <figure className="overflow-hidden rounded-3xl border" style={{ borderColor: tint(theme.primary, 0.3) }}>
                            <img src={l.image} alt={l.title} loading="lazy" className="w-full object-cover" />
                            <figcaption className="flex justify-between border-t px-4 py-2 font-mono text-[11px] uppercase tracking-[0.2em] text-zinc-500"
                                style={{ borderColor: tint(theme.primary, 0.2) }}>
                                <span>before</span><span>after</span>
                            </figcaption>
                        </figure>
                        <div>
                            <p className="font-mono text-[11px] uppercase tracking-[0.28em]" style={{ color: theme.ink || theme.primary }}>
                                {String(i + 1).padStart(2, "0")} · {l.title}
                            </p>
                            <div className="mt-4 space-y-3">
                                <p className="flex gap-3 text-base text-zinc-300">
                                    <AlertTriangle size={17} className="mt-0.5 shrink-0 text-amber-300" /> {l.before}
                                </p>
                                <p className="flex gap-3 text-base text-zinc-100">
                                    <Check size={17} className="mt-0.5 shrink-0" style={{ color: theme.ink || theme.primary }} /> {l.after}
                                </p>
                            </div>
                            <p className="mt-5 border-l-2 pl-4 font-display text-lg font-bold leading-snug"
                                style={{ borderColor: theme.primary }}>{l.rule}</p>
                        </div>
                    </div>
                </Reveal>
            ))}
        </div>
    );
}
